export default __webpack_public_path__ + "static/alexg-banner-5c9adcc5a84f2a0040d178b863516e39.webp";